<template>
  <question-group :headline="'You have completed '+blast.assignment.name">
    <div v-if="blast.assignment.features.reviews && !vm.peerReviewPending">
      <div v-if="vm.activeReview">
        <p>You have {{ blast.reviewsAvailableCount }} peer review(s) available.</p>
        <btn @click.prevent="vm.setActiveTab('rate')">Rate your peers</btn>
      </div>
      <p v-else>{{ noReviewsAvailableMessage }}</p>
    </div>
  </question-group>
</template>

<script>

  import sidebar from "./sidebar"

  export default {
    name: 'assignmentSubmitted',
    mixins: [sidebar]
  }
</script>



// WEBPACK FOOTER //
// src/components/BlastStudent/sidebar/assignmentSubmitted.vue